// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__rfgZa","title":"style_title__dQ1zM","CTA":"style_CTA__L0ekP"};